import './CountryFlag.css';
import { GERMANY_FLAG_IMAGE, isGermanyCode } from '../utils/countryFlags';

type Props = {
  code?: string | null;
  fallback?: string | null;
  label?: string;
  size?: 'small' | 'medium' | 'large';
};

export default function CountryFlag({ code, fallback, label, size = 'medium' }: Props) {
  const normalized = (code || '').toUpperCase();
  const isGermany = isGermanyCode(code);
  const style = ['IT', 'ITA'].includes(normalized)
    ? 'italy'
    : ['RO', 'ROU'].includes(normalized)
      ? 'romania'
      : isGermany
        ? 'germany'
        : 'fallback';
  // Germany always uses the local bundled flag asset; ignore any Unsplash/remote fallback.
  const image = isGermany
    ? GERMANY_FLAG_IMAGE
    : typeof fallback === 'string' && /^https?:\/\//.test(fallback) ? fallback : null;

  return (
    <span
      className={`country-flag-icon country-flag-${style} country-flag-${size}`}
      role="img"
      aria-label={label || normalized || 'Country'}
    >
      {image ? (
        <img src={image} alt={label || normalized || 'Country flag'} className="country-flag-img" loading="lazy" />
      ) : style === 'fallback' ? (
        fallback || '🎓'
      ) : null}
    </span>
  );
}
